import { render, staticRenderFns } from "./TippsSegment.vue?vue&type=template&id=6b11005f&"
import script from "./TippsSegment.vue?vue&type=script&lang=js&"
export * from "./TippsSegment.vue?vue&type=script&lang=js&"
import style0 from "./TippsSegment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports